import { css } from '@emotion/react';
import emotionReset from 'emotion-reset';
import { animations, ThemeType } from '@/modules/common';

export const globalStyles = (theme: ThemeType) => css`
  body,
  :host {
    font-family: ${theme.fontFamily};
  }

  ${emotionReset};

  * {
    direction: ${theme.isRtl ? 'rtl' : 'ltr'};
    box-sizing: border-box;
  }

  button {
    cursor: pointer;
    border: none;
    background-color: transparent;
    outline: none;
  }

  ${animations}
  ${theme.global};
`;
